import { ReactElement } from 'react';
import { ComponentRendering } from '@sitecore-jss/sitecore-jss/layout';

import { SpotWrapper } from 'src/SpotWrapper';

type TabNavigationContentItemProps = {
  component?: ReactElement;
  rendering?: ComponentRendering;
};

const TabNavigationContentItem = ({ component, rendering }: TabNavigationContentItemProps) => {
  return (
    <>{rendering && component && <SpotWrapper component={component} rendering={rendering} />}</>
  );
};

export default TabNavigationContentItem;
